import { customSwitch } from 'utils/customSwitchCase/customSwitch';
import { taskFilterName } from './Filters/utils';
import { TaskMetric } from './KPIMetric/Tile';

export const matchTaskFilterWithTile = (values): string => {
  if (
    values[taskFilterName.status].length == 2 &&
    values[taskFilterName.status].findIndex(x => x.value === 'Pending') !== -1 &&
    values[taskFilterName.status].findIndex(x => x.value === 'New') !== -1
  ) {
    return TaskMetric.Outstanding;
  }
  if (values[taskFilterName.status].length == 1 && values[taskFilterName.status][0].value === 'Completed') {
    return TaskMetric.Completed;
  }
  if (values[taskFilterName.status].length == 1 && values[taskFilterName.status][0].value === 'Cancelled') {
    return TaskMetric.CancelledTask;
  }
  return '';
};

export const getTaskKpiFilterPayload = filterValue => {
  const payload = {
    entity: 0,
    placementId: [],
    facilityId: [],
    orderId: [],
    taskNameId: [],
    taskCategory:
      filterValue?.category.map(x => {
        if (x.value === 'Others') return 0;
        else if (x.value === 'Missing RFO Requirements') return 1;
        else if (x.value === 'Strike Clearance Requirements') return 2;
        else return 3;
      }) ?? [],
    createdBy: filterValue?.createdBy.map(x => x.id) ?? [],
    taskStatusId:
      filterValue?.status.map(x => {
        if (x.value === 'Cancelled') return 4;
        else if (x.value === 'Pending') return 2;
        else if (x.value === 'New') return 1;
        else return 3;
      }) ?? [],
  };

  return payload;
};

export const matchTaskTileWithFilter = customSwitch({
  [TaskMetric.Outstanding]: {
    [taskFilterName.category]: [],
    [taskFilterName.assignedTo]: [
      {
        id: 0,
        name: 'Me',
        value: 'Me',
      },
    ],
    [taskFilterName.createdBy]: [],
    [taskFilterName.status]: [
      {
        id: 0,
        name: 'New',
        value: 'New',
      },
      {
        id: 1,
        name: 'Pending',
        value: 'Pending',
      },
    ],
  },
  [TaskMetric.Completed]: {
    [taskFilterName.category]: [],
    [taskFilterName.createdBy]: [],
    [taskFilterName.assignedTo]: [
      {
        id: 0,
        name: 'Me',
        value: 'Me',
      },
    ],
    [taskFilterName.status]: [
      {
        id: 0,
        name: 'Completed',
        value: 'Completed',
      },
    ],
  },
  [TaskMetric.AverageCompletionTime]: {
    [taskFilterName.category]: [],
    [taskFilterName.createdBy]: [],
    [taskFilterName.assignedTo]: [
      {
        id: 0,
        name: 'Me',
        value: 'Me',
      },
    ],
    [taskFilterName.status]: [
      {
        id: 0,
        name: 'Completed',
        value: 'Completed',
      },
    ],
  },
  [TaskMetric.CancelledTask]: {
    [taskFilterName.category]: [],
    [taskFilterName.createdBy]: [],
    [taskFilterName.assignedTo]: [
      {
        id: 0,
        name: 'Me',
        value: 'Me',
      },
    ],
    [taskFilterName.status]: [
      {
        id: 0,
        name: 'Cancelled',
        value: 'Cancelled',
      },
    ],
  },
})(undefined);
